import React, { useContext, useState } from "react";
import { Col, Form } from "react-bootstrap";
import { BlouseContext } from "../../../context/blouseContext";
import SleeveDisplay from "./sleevedisplay";
import { useTranslation } from 'react-i18next';

const SleeveList=()=>{
    const {sleeveData}=useContext(BlouseContext);
    const [filterSleeve,setFilterSleeve]=useState("");
    const { t } = useTranslation();

    const FilterData=sleeveData.filter(each=>(
        each.name.toLowerCase().includes(filterSleeve.toLowerCase())
      ))


    return(
        <>
        <div className="d-flex mt-2">
           <Col className="">
            <Form.Control type="text" 
            onChange={(e)=>setFilterSleeve(e.target.value)}
            placeholder="Search By Items..." />
            </Col>
            <Col className="mx-1 mt-2" lg={5} sm={5} md={5}>
            <p className="text-dark px-1">{t('main.search_total')} {FilterData.length}</p>
            </Col>
        </div>
        <div className="leftside_items_sleeve">
           {FilterData?.map(each=>(
                  <SleeveDisplay key={each.id}
                  icon={each.icon}
                  name={each.name}
                  data={each}>
                  </SleeveDisplay>
                 ))}
        </div>
        </>
    )
}
export default SleeveList